import {Observable} from 'rxjs';
import {educatAPI, RestQueryParams} from 'educat-common-web';


export function getMentorByShortIdAPI(authToken: string, mentorId: string): Observable<any> {
    return educatAPI.get(
        `mentors/short/${mentorId}`,
        new RestQueryParams(),
        {
            Authorization: `Bearer ${authToken}`
        }
    );
}
